import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPostRequest } from '../../../api/requestUtil';

export const getBlogReviewsById = createAsyncThunk<
  BlogReviewsListSuccessType,
  string | number | undefined,
  { rejectValue: BlogReviewError }
>('get-blog-reviews-by-id', async (blogId, { rejectWithValue }) => {
  try {
    const response = await sendGetRequest(`/api/blogs/${blogId}/reviews/`);
    return response;
  } catch (error: any) {
    return;
  }
});

export const addBlogReview = createAsyncThunk(
  'add-blog-review',
  async (body: SubmitBlogReviewRequestType, { getState }) => {
    const state = getState() as AppState;
    const token = state.user.authToken;

    return sendPostRequest('/api/reviews/create/', body, token);
  }
);
